@for (faq of items(); track faq.question; let i = $index) {
  <div class="faq-item" [class.open]="openIndex() === i">
    <button class="faq-question" (click)="toggle(i)">
      {{ faq.question }}
      <htx-icon icon="expand_more"></htx-icon>
    </button>
    <div class="faq-answer">
      {{ faq.answer }}
    </div>
  </div>
}
